const MINIMUM_NUMBER = 215;

export default ({ number = MINIMUM_NUMBER, offset }) => {
    return parseInt(number) + parseInt(offset);
};
